// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__7cCXd","details":"styles_details__yZO9v"};